var app = angular.module('leonardo');

var DirectFilters = function($rootScope) {
  return {
    templateUrl: 'views/templates/filter/direct-filters.html',
    link: function (scope, element, attrs, controller, transclude) {
      scope.filter = function(){
        $rootScope.$broadcast('reports:filter');
      };
    }
  };
};

app.directive('directFilters', ['$rootScope', DirectFilters]);
